.rv-score-chart-container {
  display: flex;
  flex-direction: row;
  height: inherit;
}

:host {
  height: inherit;
}
